import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
import styles from './styles.scss';

export default class Label extends Component {
  static propTypes = {
    label: PropTypes.node,
    required: PropTypes.bool,
    // eslint-disable-next-line consistent-return
    name: (props, propName, componentName) => {
      if (props[propName]) {
        return new Error(
          `The prop ${propName} supplied to ${componentName} is deprecated. Use "htmlFor" instead.`,
        );
      }
    },
    htmlFor: PropTypes.string.isRequired,
    className: PropTypes.string,
    tooltip: PropTypes.node,
    children: PropTypes.node,
  };

  static defaultProps = {
    className: 'col-md-4',
    tooltip: null,
  };

  render() {
    const { label, name, htmlFor, required, className, tooltip, children } = this.props;

    return label || children ? (
      <label htmlFor={htmlFor || name} className={`${className} ${styles.label}`}>
        <span>
          {label}
          {required ? '*' : ''}
        </span>
        {tooltip && (
          <span>
            <Tooltip tooltip={tooltip} />
          </span>
        )}
        {children}
      </label>
    ) : null;
  }
}
